import React, { Component } from "react";
import "./i.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCashRegister,
  faShoppingCart,
  faChartLine,
  faCloud,
  faStore,
  faMobileAlt,
} from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";
import Header from "./Header";
import AppHighlights from "./AppHighlights";
import Apresentacao from "./Apresentacao";
import Resultados from "./Resultados";
import Footer from "./Footer";
import ComoFunciona from "./ComoFunciona";
import Depoimentos from "./Depoimentos";
import PorQue from "./PorQueEstacionamento";
export default class Inicio extends Component {
  render() {
    return (
      <>
        <Header />
        <AppHighlights />
        <Apresentacao />
        <Resultados />
        <ComoFunciona />
        <PorQue />
        <Depoimentos />
        <Footer />
      </>
    );
  }
}
